import React from 'react';
import styles from '../styles.module.css';
import MainIcons from '@/icons/main';
import { Car, Plate, plateSize, plateType } from '@/commonTypes';
import ArrowIconRotate from './ArrowIconRotate';
import useWindowDimensions from '@/functions/useWindowDimensions';

export default function PlateBadge({
  car,
  type = 'small',
  region = 'ایران',
  size = 'sm',
  className = '',
  showAnimation = false,
  classA = '',
  classB = '',
  classC = '',
}: {
  car?: Car;
  type?: plateType;
  region?: string;
  size?: plateSize;
  className?: string;
  showAnimation?: boolean;
  classA?: string;
  classB?: string;
  classC?: string;
}) {
  const { width } = useWindowDimensions();
  console.log('ccccccc========', car?.plate);
  return (
    <>
      {type == 'small' ? (
        <div className={`${styles.btn} ${className}`}>
          {width && width > 550 ? (
            <span dir="ltr" className={styles.chip}>
              <span className={styles.flag}>
                <span className={styles.flagGreen} />
                <span className={styles.flagWhite} />
                <span className={styles.flagRed} />
              </span>
              {/* <span className={styles.chipNum}>
                {car?.plate?.a} {car?.plate?.b} {car?.plate?.c}
              </span> */}
              <span className={styles.chipNum}>
                {car?.plate?.a}
                {' \u200E '}
                {car?.plate?.b}
                {' \u200E '}
                {car?.plate?.c}
              </span>
            </span>
          ) : (
            <MainIcons.carIcon fill="var(--paper)" height="26px" />
          )}
          <span className={styles.name}>{car?.name}</span>
          <ArrowIconRotate />
        </div>
      ) : (
        <span dir="ltr" className={`${styles.plate} ${className} relative`} data-size={size}>
          {showAnimation && <div className={`${styles.sheen}`}></div>}
          <span className={styles.flag}>
            <span className={styles.flagStripes}>
              <span className={styles.green} />
              <span className={styles.white} />
              <span className={styles.red} />
            </span>
            <span className={styles.flagText}>I.R.IRAN</span>
          </span>
          <span className={`${styles.a} ${classA}`}>{car?.plate?.a}</span>
          <span className={`${styles.b} ${classB}`}>{car?.plate?.b}</span>
          <span className={`${styles.c} ${classC}`}>{car?.plate?.c}</span>
          <span className={styles.region}>
            <span className={styles.regionNum}>{car?.plate?.r}</span>
            {region ? <span className={styles.regionLabel}>{region}</span> : null}
          </span>
        </span>
      )}
    </>
  );
}
